import { render, staticRenderFns } from "./MyOverlays.vue?vue&type=template&id=3fa63c48&scoped=true&"
import script from "./MyOverlays.vue?vue&type=script&lang=js&"
export * from "./MyOverlays.vue?vue&type=script&lang=js&"
import style0 from "./MyOverlays.vue?vue&type=style&index=0&id=3fa63c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa63c48",
  null
  
)

export default component.exports